import React, { useEffect, useState } from 'react';
import { translatedMessage } from '../../service/LanguageService';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import DOMPurify from 'dompurify';
import { Divider } from 'primereact/divider';
import { QuestionType } from './QuestionType';

const QuestionViewComponent = (props) => {
    const [question, setQuestion] = useState({});

    useEffect(() => {
        setQuestion(props.value);
    }, [props]);

    return (
        <div key={question?.id} className="grid w-full">
            <div className="col-12">
                <b>{question?.name}</b> ({translatedMessage('QuestionType.' + question?.questionType)})
            </div>
            <div className="col-12">
                <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question?.questionContent) }} />
            </div>

            {question?.answers?.map((answer, index) => {
                return (
                    <div key={answer.id} className="col-12 ml-4">
                        <div className="grid">
                            {question?.questionType === QuestionType.SINGLE_SELECTION && (
                                <>
                                    <div className="col-1">
                                        <RadioButton checked={answer.correctAnswer} />
                                        {' ' + answer.name}
                                    </div>
                                    <div className="col-10">
                                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.answerContent) }} />
                                    </div>
                                </>
                            )}
                            {question?.questionType === QuestionType.MULTIPLE_SELECTION && (
                                <>
                                    <div className="col-1">
                                        <Checkbox checked={answer.correctAnswer}></Checkbox>
                                        {' ' + answer.name}
                                    </div>
                                    <div className="col-10">
                                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.answerContent) }} />
                                    </div>
                                </>
                            )}
                            {question?.questionType === QuestionType.ORDERING_ELEMENTS && (
                                <>
                                    <div className="col-1">
                                        <div className="square">
                                            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.correctOrder) }} />
                                        </div>
                                    </div>
                                    <div className="col-10">
                                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.answerContent) }} />
                                    </div>
                                </>
                            )}
                            {question?.questionType === QuestionType.MATCHING_ELEMENTS && (
                                <>
                                    <div className="col-1">
                                        <div className="square">{answer.name}</div>
                                    </div>
                                    <div className="col-5">
                                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.answerContent) }} />
                                    </div>
                                    <div className="col-1">
                                        <div className="square">
                                            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.correctOrder) }} />
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer.secondContent) }} />
                                    </div>
                                </>
                            )}
                        </div>
                        <Divider type="dashed" className="no-margin" />
                    </div>
                );
            })}

            {[QuestionType.FREE_TEXT, QuestionType.FILL_IN_THE_BLANKS].includes(question?.questionType) ? (
                <>
                    <div className="col-1 bold">{translatedMessage('competition.subjectProposal.question.comment')}:</div>
                    <div className="col-11">
                        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question?.comment) }} />
                    </div>
                </>
            ) : (
                ''
            )}

            <div className="col-1 bold">{translatedMessage('competition.subjectProposal.question.score')}</div>
            <div className="col-11">{question?.score}</div>
        </div>
    );
};

export default QuestionViewComponent;
